module.exports = __webpack_public_path__ + "img/naborisk.36c49cf9.jpg";